module.exports = __webpack_public_path__ + "img/in-one-mobile.b61ef31c.jpg";